import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
import { BEHAVIOR_NEXT_EVENT_DELAY } from "../utils/variables";
class DragBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.drag;
        this.handler = (event) => this.onDrag(event);
    }
    onDrag(event) {
        if (this.isOnHandler) {
            return;
        }
        this.isOnHandler = true;
        setTimeout(() => {
            this.addLog(event, this.id);
            this.isOnHandler = false;
        }, BEHAVIOR_NEXT_EVENT_DELAY);
    }
}
export default DragBehavior;
